import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {AccountService} from '@core/services';

@Component({
    selector: 'app-change-password-dialog',
    templateUrl: './change-password-dialog.component.html'
})
export class ChangePasswordDialogComponent {
    oldPassword = '';
    password = '';
    passwordConfirm = '';
    dangGui = false;

    constructor(public activeModal: NgbActiveModal,
                private accountService: AccountService,
                private toastr: ToastrService) {
    }

    doiMatKhau(): void {
        if (!this.oldPassword || !this.password) {
            this.toastr.error('Mật khẩu cũ và mật khẩu mới đều bắt buộc');
            return;
        }
        if (this.password.length < 8) {
            this.toastr.error('Mật khẩu mới phải từ 8 ký tự');
            return;
        }
        // Đối chiếu ở ĐÂY chứ không để backend bắt: backend không nhận ô xác nhận, nên gõ lệch
        // sẽ đổi thành công sang một chuỗi người dùng không biết mình vừa đặt.
        if (this.password !== this.passwordConfirm) {
            this.toastr.error('Hai ô mật khẩu mới không khớp');
            return;
        }
        this.dangGui = true;
        this.accountService.changePassword(this.oldPassword, this.password).subscribe(value => {
            this.dangGui = false;
            // AuthInterceptor nuốt mọi lỗi HTTP khác 401: nó hiện toast rồi trả về null, nên
            // subscriber KHÔNG nhận error. `null` ở đây nghĩa là đã hỏng và người dùng đã thấy
            // lý do — chỉ cần đừng báo thành công và đừng đóng hộp thoại.
            if (!value) {
                return;
            }
            this.toastr.success('Đã đổi mật khẩu');
            this.activeModal.close(true);
        });
    }

    close(): void {
        this.activeModal.dismiss();
    }
}
